export class BadRequestException implements Error {
    public name = 'Bad Request Exception'
    public message = 'Secret exceeded maximum string length of 1000000'
}
